import { createApp } from 'vue';
import GradientText from '../../components/GradientText';

/**
 * Initializes animated gradient text for claim sections.
 *
 * Scans for headings with colored spans (from CKEditor) and wraps them
 * into a single cohesive animated GradientText component.
 */
const initGradientText = () => {
  const claimTitles = document.querySelectorAll(
    '.front-page-sections__claim-text h2',
  );

  if (!claimTitles.length) return;

  claimTitles.forEach((title) => {
    const spans = title.querySelectorAll('span[style*="color"]');
    if (!spans.length) return;

    // Extract colors from styled spans to form the shared palette.
    const colors = Array.from(spans).map((span) => span.style.color);

    // Ensure a smooth loop or valid gradient fallback.
    if (colors.length > 1) {
      colors.push(colors[0]);
    } else if (colors.length === 1) {
      colors.push('#bd003c'); // $color-main
      colors.push('#ffffff'); // $color-white
      colors.push(colors[0]);
    }

    // Identify the range spanning all colored portions.
    const firstSpan = spans[0];
    const lastSpan = spans[spans.length - 1];

    const range = document.createRange();
    range.setStartBefore(firstSpan);
    range.setEndAfter(lastSpan);

    // Extract into a wrapper for the Vue instance.
    const container = document.createElement('span');
    container.appendChild(range.extractContents());
    range.insertNode(container);

    const originalHTML = container.innerHTML;

    createApp({
      template: `
        <GradientText :colors="${JSON.stringify(colors).replace(/"/g, "'")}">
          <span v-html="content"></span>
        </GradientText>
      `,
      data() {
        return {
          content: originalHTML,
        };
      },
      components: { GradientText },
    }).mount(container);
  });
};

export default initGradientText;
